export const getColor = (percentage) => {
  if (percentage >= 100) return 'success';
  if (percentage >= 75) return 'primary';
  if (percentage >= 50) return 'yellow';
  if (percentage >= 25) return 'orange';
  if (percentage >= 1) return 'danger';
  return 'neutral';
};
